import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import Vue from "vue";
import VueChartkick from "vue-chartkick";
import Chart from "chart.js";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "@/plugins/vue-i18n";
import "@/plugins/numeral";
import moment from "moment";
import "moment/locale/fr";

moment.locale("fr");
import "@/utils/vee-validate";

import axios from "axios";

// flatPickr
import VueFlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/material_blue.css";
import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";
flatpickr.localize(French);
Vue.use(VueFlatPickr);

//Multiselect
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
Vue.component("multiselect", Multiselect);

// SweetAlert
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

//FontAwesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
} from "@fortawesome/vue-fontawesome";
import { dom } from "@fortawesome/fontawesome-svg-core";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const appInsights = new ApplicationInsights({
  config: {
    connectionString: window.KEY_APP_INSIGHT,
  },
});
appInsights.loadAppInsights();
const telemetryInitializer = (envelope) => {
  envelope.data.someField =
    "Bypass Telemetry Analyzer log reporting";
};
appInsights.addTelemetryInitializer(telemetryInitializer);
appInsights.trackPageView();
appInsights.trackException();
appInsights.trackTrace();
appInsights.trackMetric();
appInsights.trackEvent();

library.add(fas);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);
dom.watch();

//Config Vue
Vue.config.productionTip = false;

VueChartkick.configure({ language: "fr" });
Vue.use(VueChartkick, { adapter: Chart });
Vue.use(BootstrapVue, {
  breakpoints: ["sm", "md", "xl"],
});
Vue.use(BootstrapVueIcons);

if (!String.prototype.format) {
  String.prototype.format = function () {
    var args = arguments;
    return this.replace(
      /{(\d+)(?::([^}]+))?}/g,
      function (match, number, format) {
        if (typeof args[number] === "undefined") {
          return "";
        } else if (!format) {
          return args[number];
        } else {
          //On considère que c'est une date
          return moment(args[number]).format(format);
        }
      }
    );
  };
}

import AuthMixin from "@/mixins/authMixin";
Vue.mixin(AuthMixin);

new Vue({
  router,
  store,
  beforeCreate() {
    this.$store.commit("authentication/init");

    /*
      before the request fires
    */
    axios.interceptors.request.use((config) => {
      // 20 000ms
      config.timeout = 20000;
      if (
        config.url.includes(window.VUE_APP_API_HOST) &&
        this.$store.state.authentication.accessToken
      ) {
        const accessToken = this.$store.state.authentication.accessToken;
        config.headers.Authorization = `Bearer ${accessToken}`;
      }

      return config;
    });

    /*
      when the request send a result
    */
    axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        const { config, response } = error;

        // interceptor on error to refresh the token

        if (config._retry) {
          // this request is a retry so throw an error
          throw error;
        }

        if (response && ![401, 403].includes(response.status)) {
          // if it is not a Cors, an Unauthorized or a Forbidden error throw error
          // response === undefined <=> cors error
          throw error;
        }

        const requestUrl = config.url;

        if (requestUrl.includes("/connect/token")) {
          // if the refresh token failed logout and throw error
          this.$store.dispatch("authentication/logout");

          throw error;
        }

        try {
          // then try to refresh the token

          await this.$store.dispatch("authentication/ensureToken");
        } catch (e) {
          this.$store.dispatch("authentication/logout");

          throw error;
        }

        try {
          // redo the request
          const accessToken = this.$store.state.authentication.accessToken;
          config.headers["Authorization"] = `Bearer ${accessToken}`;
          config._retry = true;
          return axios.request(config);
        } catch (e) {
          throw error;
        }
      }
    );
  },
  render: (h) => h(App),
  i18n,
}).$mount("#app");
